import { height160, heroIconsSize } from "@/components/Styles"
import { CircularProgress } from "@mui/material"

function LoginCircularProgress() {
  return (
    <div className="flex-center-center" style={height160}>
      <CircularProgress size={heroIconsSize} />
    </div>
  )
}

export default LoginCircularProgress
